import { Component, AfterViewInit, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

import { ShareddtaService } from '@app/services/shareddta.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AddressService } from '@app/services/address.service';
import { AuthServiceService } from '@app/services/auth-service.service';
import { CompaniesService } from '@app/services/companies.service';
import { DialogService } from '@app/services/dialog.service';
import { ToastService } from '@app/services/toast.service';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { Observable, Subject, debounceTime, distinctUntilChanged, take, takeUntil } from 'rxjs';
import { AddAddressListingComponent } from '../add-address-listing/add-address-listing.component';
import { BreadcrumbService } from '@app/services/breadcrumb.service';

export interface Company {
  id: number;
  name: string;
  industry: string;
  type: 'client' | 'supplier' | 'partner';
  totalOrders: number;
  initials: string;
  avatarClass: string;
}

export interface Address {
  id: number;
  street: string;
  city: string;
  fullAddress: string;
}

@Component({
  selector: 'app-companies-listing',
  templateUrl: './companies-listing.component.html',
  styleUrl: './companies-listing.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class CompaniesListingComponent implements AfterViewInit, OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private mainSearch$ = new Subject<string>();
  private mergeSearch$ = new Subject<string>();
  private addressSearch$ = new Subject<string>();

  // Data
  companies: Company[] = [
    { id: 1, name: 'Maxum Drywall', industry: 'Construction', type: 'client', totalOrders: 1247, initials: 'MD', avatarClass: 'avatar-1' },
    { id: 2, name: 'Msr Mechanical', industry: 'HVAC', type: 'client', totalOrders: 856, initials: 'MM', avatarClass: 'avatar-2' },
    { id: 3, name: 'Wesco', industry: 'Electrical Supply', type: 'supplier', totalOrders: 2134, initials: 'W', avatarClass: 'avatar-3' },
    { id: 4, name: 'Enterprise Trucks', industry: 'Transportation', type: 'partner', totalOrders: 543, initials: 'ET', avatarClass: 'avatar-4' },
    { id: 5, name: 'Dunera', industry: 'Manufacturing', type: 'client', totalOrders: 789, initials: 'D', avatarClass: 'avatar-5' },
    { id: 6, name: 'Bayview Highrise', industry: 'Real Estate', type: 'client', totalOrders: 234, initials: 'BH', avatarClass: 'avatar-6' }
  ];

  addresses: Address[] = [
    { id: 1, street: '1 Yonge Street', city: 'Toronto, ON, Canada', fullAddress: '1 Yonge Street, Toronto, ON, Canada' },
    { id: 2, street: '209 Steeles Avenue West', city: 'Brampton, ON', fullAddress: '209 Steeles Avenue West, Brampton, ON' },
    { id: 3, street: '333 Courtneypark Drive East', city: 'Mississauga, ON', fullAddress: '333 Courtneypark Drive East, Mississauga, ON' },
    { id: 4, street: '575 Bloor St E', city: 'Toronto, ON', fullAddress: '575 Bloor St E, Toronto, ON' }
  ];

  // Filtered data
  filteredCompanies: Company[] = [];

  // Filter state
  activeFilter: string = 'all';
  activeCompanyType: string = ''; // '' = All, 'store', 'contractor'
  searchTerm: string = '';

  // Modal states
  showMergeModal: boolean = false;
  showEditModal: boolean = false;
  showAddModal: boolean = false;
  showDeleteModal: boolean = false;
  showviewModal: boolean = false;

  // Modal data
  currentCompany: any = null;
  mergeToInput: string = '';
  mergeToId: number | null = null;
  showMergeDropdown: boolean = false;

  editCompanyName: string = '';
  addressInput: string = '';
  addressId: number | null = null;
  showAddressDropdown: boolean = false;

  // Dropdown filtered lists
  filteredMergeCompanies: any[] = [];
  filteredAddresses: Address[] = [];

  // Summary counts from API - locked on first load, never overwritten
  companySummary: any = null;
  summaryLoaded: boolean = false;

  // Pagination
  paginationInfo: string = '';

  constructor(
    public router: Router,
    private dialogService: DialogService,
    private addressService: AddressService,
    public authService: AuthServiceService,
    private companyService: CompaniesService,
    private toastr: ToastrService,
    private toast: ToastService,
    public dialog: MatDialog,
    private shareddta: ShareddtaService,
    private breadcrumbService: BreadcrumbService
  ) { }

  ngAfterViewInit(): void {
    this.shareddta.signalPageReady();
  }

  ngOnInit(): void {
    this.breadcrumbService.set([
      { label: 'Dashboard', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6', action: () => this.router.navigate(['/admin/dashboard']) },
      { label: 'Companies' }
    ]);
    this.filteredCompanies = [...this.companies];
    this.updatePaginationInfo();
    // this.loadSummaryOnce();  // sirf summary ek baar fresh load karo
    this.allCompanyListing(this.currentPage);

    // Main Search Debounce
    this.mainSearch$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe(query => {
      this.cross = query.length > 0;
      this.currentPage = 1;
      this.allCompanyListing(this.currentPage, query, this.activeCompanyType);
    });

    // Merge Search Debounce
    this.mergeSearch$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe(search => {
      this.companylisting1(this.currentPage, search);
    });

    // Address Search Debounce
    this.addressSearch$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe(search => {
      this.addressList(1, search);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // ============================================
  // NEW - All Company Listing (all-company-listing API)
  // ============================================

  // Summary sirf ek baar load hogi - koi bhi filter change isko touch nahi karega
  loadSummaryOnce(): void {
    this.companyService.allCompanySearch(1)
      .subscribe({
        next: (data: any) => {
          if (data?.result?.summary) {
            this.companySummary = data.result.summary;
          }
        },
        error: () => { }
      });
  }

  isLoading: boolean = true;
  allCompanyListing(page: number, search_text?: string, companyType?: string): void {
    this.isLoading = true;
    this.companyService.allCompanySearch(page, search_text, companyType)
      .subscribe({
        next: (data: any) => {
          this.isLoading = false;
          this.companyData = data?.result?.results || [];
          this.companiesDataCount = data?.result?.count || 0;
          this.totalCompanies = data?.result?.count || 0;

          // Update summary counts from API
          if (data?.result?.summary) {
            this.companySummary = data.result.summary;
          }
          this.companyData.forEach((element: any, index: number) => {
            element['sNo'] = index + 1 + (20 * (this.currentPage - 1));
            const randomAvatar = Math.floor(Math.random() * 6) + 1;
            element['avatarClass'] = `avatar-${randomAvatar}`;
          });
        },
        error: (err: any) => {
          this.isLoading = false;
          if (navigator.onLine && err?.status !== 0) {
            this.toast.show('error', err?.resultDescription || 'Something went wrong');
          }
        }
      });
  }

  // ============================================
  // SEARCH & FILTER
  // ============================================

  onSearch(): void {
    this.mainSearch$.next(this.searchTerm.toLowerCase().trim());
  }

  onFilterChange(filter: string): void {
    if (filter === 'all') {
      this.activeCompanyType = '';
    } else if (filter === 'others') {
      this.activeCompanyType = 'no_orders';
    } else {
      this.activeCompanyType = filter;
    }
    
    this.activeFilter = filter;
    this.searchTerm = '';
    this.currentPage = 1;
    this.allCompanyListing(this.currentPage, '', this.activeCompanyType);
  }

  private applyFilters(): void {
    let result = [...this.companies];

    if (this.activeFilter !== 'all') {
      result = result.filter(c => c.type === this.activeFilter);
    }

    if (this.searchTerm.trim()) {
      const search = this.searchTerm.toLowerCase();
      result = result.filter(c => c.name.toLowerCase().includes(search));
    }

    this.filteredCompanies = result;
    this.updatePaginationInfo();
  }

  private updatePaginationInfo(): void {
    const count = this.filteredCompanies.length;
    if (count === 0) {
      this.paginationInfo = 'No companies found';
    } else {
      this.paginationInfo = `Showing 1 - ${count} of ${count} companies`;
    }
  }

  getFilterCount(type: string): number {
    if (!this.companySummary) return 0;
    if (type === 'all') return this.companySummary.total_companies || 0;
    if (type === 'store') return this.companySummary.store_count || 0;
    if (type === 'contractor') return this.companySummary.contractor_count || 0;
    if (type === 'others') return this.companySummary.no_orders_count || 0;
    return 0;
  }

  // ============================================
  // ACTIONS
  // ============================================
  isAdded: boolean = false;
  isMerge: boolean = false;
  isEdit: boolean = false;

  addCompany(): void {
    this.showAddModal = true;
    this.isAdded = false;
    this.addressInputselection == false;
    this.addressInput = '';
    this.addressId = null;
    this.addressInput = '';
    this.editCompanyName = '';
    console.log('Navigate to add company page');
  }

  viewCompanyName: any;
  viewCompany(company: any): void {
    console.log('View company:', company);
    localStorage.setItem('viewCompany', 'true');
    this.showviewModal = true;
    this.viewCompanyName = company.company;
    this.companylisting2(this.viewCurrentPage, company.company);
  }

  // ============================================
  // MERGE MODAL
  // ============================================

  openMergeModal(company: any): void {
    this.currentCompany = company;
    this.mergeToInput = '';
    this.isMerge = false;
    this.mergeToId = null;
    this.showMergeDropdown = false;

    this.filteredMergeCompanies = this.companies.filter(c => c.id !== company.id);

    this.showMergeModal = true;
  }

  closeMergeModal(): void {
    this.showMergeModal = false;
    this.showMergeDropdown = false;
  }

  onMergeInputFocus(): void {
    this.showMergeDropdown = true;
  }

  onMergeInputChange(): void {
    this.showMergeDropdown = true;
    this.mergeSearch$.next(this.mergeToInput.toLowerCase());
  }

  selectMergeCompany(company: any): void {
    this.mergeToId = company.id;
    this.mergeToInput = company.company;
    this.showMergeDropdown = false;
  }

  confirmMerge(): void {
    if (!this.mergeToId) {
      this.isMerge = true;
      return;
    }

    console.log(`Merging company ${this.currentCompany?.id} to ${this.mergeToId}`);

    this.isMerge = false;
    const formData = new FormData();
    formData.append('merge_from', String(this.currentCompany?.id ?? ''));
    formData.append('merge_to', String(this.mergeToId ?? ''));
    this.companyService.mergeCompany(formData).subscribe({
      next: (response: any) => {
        if (response?.resultDescription) {
          this.toast.show('success', response.resultDescription);
          this.allCompanyListing(this.currentPage, this.searchTerm, this.activeCompanyType);
          this.closeMergeModal();
        } else if (response?.errorMessage) {
          this.toast.show('error', response?.errorMessage);
        }
      },
      error: (err: any) => {
        if (navigator.onLine && err?.status !== 0) {
          this.toast.show('error', err?.resultDescription || 'Something went wrong');
        }
        console.error('Error merging company:', err);
      }
    });
  }

  // ============================================
  // EDIT MODAL
  // ============================================

  openEditModal(company: any): void {
    this.currentCompany = company;
    this.editCompanyName = company.company;
    this.addressInput = company.address.address;
    this.addressId = company.address.id;
    this.showAddressDropdown = false;
    this.addressInputselection = true;

    this.showEditModal = true;
  }

  async closeAddModel(): Promise<void> {
    this.showAddModal = false;
    this.showAddressDropdown = false;
  }

  async closeEditModal(): Promise<void> {
    this.showEditModal = false;
    this.showAddressDropdown = false;
  }

  closeViewModel() {
    this.showviewModal = false;
    this.showAddressDropdown = false;
    localStorage.setItem('viewCompany', 'false');
  }

  onAddressInputFocus(): void {
    this.showAddressDropdown = true;
  }

  onAddressInputChange(): void {
    this.addressId = null;
    this.addressInputselection = false;
    this.showAddressDropdown = true;
    this.addressSearch$.next(this.addressInput.toLowerCase());
  }

  addressInputselection: boolean = false;

  selectAddress(address: any): void {
    this.addressId = address.id;
    this.addressInput = address.address;
    this.addressInputselection = true;
    this.showAddressDropdown = false;
  }

  addNewAddress(): void {
    console.log('Navigate to add address page');
    this.router.navigate(['/admin/address/add']);
    this.closeEditModal();
  }

  confirmEdit(): void {
    if (!this.editCompanyName.trim()) {
      this.isEdit = true;
      return;
    }
    if (!this.addressInput.trim() && this.addressInputselection == false) {
      this.isEdit = true;
      return;
    }
    if (this.addressInputselection == false) {
      this.isEdit = true;
      return;
    }
    this.isEdit = false;
    const formData = new FormData();
    formData.append('company', this.editCompanyName);
    formData.append('address', this.addressId ? this.addressId.toString() : '');
    this.companyService.editCompany(this.currentCompany?.id, formData).subscribe({
      next: (response) => {
        if (response.resultDescription) {
          this.toast.show('success', response.resultDescription);
          if (localStorage.getItem('viewCompany') === 'true') {
            this.companylisting2(this.viewCurrentPage, this.viewCompanyName);
          }
          this.closeEditModal();
          this.allCompanyListing(this.currentPage, this.searchTerm, this.activeCompanyType);
        }
        if (response.errorMessage) {
          this.toast.show('error', response?.errorMessage);
        }
      },
      error: (err) => {
        if (navigator.onLine && err?.status !== 0) {
          this.toast.show('error', err?.resultDescription || 'Something went wrong');
        }
      },
    });

    console.log(`Updating company ${this.currentCompany?.id}: ${this.editCompanyName}, Address: ${this.addressId}`);
  }

  confirmAdd(): void {
    if (!this.editCompanyName.trim()) {
      this.isAdded = true;
      return;
    }
    if (!this.addressInput.trim() && this.addressInputselection == false) {
      this.isAdded = true;
      return;
    }
    if (this.addressInputselection == false) {
      this.isAdded = true;
      return;
    }
    this.isAdded = false;
    const formData = new FormData();
    formData.append('address', String(this.addressId ?? ''));
    formData.append('company', String(this.editCompanyName ?? ''));
    this.companyService.companynameAdd(formData).subscribe({
      next: (response: any) => {
        if (response?.resultDescription) {
          this.toast.show('success', response.resultDescription);
          this.allCompanyListing(this.currentPage, this.searchTerm, this.activeCompanyType);
          this.closeAddModel();
        } else if (response?.errorMessage) {
          this.toast.show('error', response?.errorMessage);
        }
      },
      error: (err: any) => {
        if (navigator.onLine && err?.status !== 0) {
          this.toast.show('error', err?.resultDescription || 'Something went wrong');
        }
        console.error('Error adding company:', err);
      }
    });
  }

  // ============================================
  // DELETE
  // ============================================
  async deleteOrder(companyId: any): Promise<void> {
    const confirmed = await this.dialogService.confirm(
      'Delete Company',
      'Are you sure you want to delete this company? This action cannot be undone.',
      'Delete',
      'Cancel'
    );

    if (confirmed?.confirmed) {
      this.companyService.companyDelete(companyId).subscribe(
        (data: any) => {
          if (this.authService.resultCodeError(data)) {
            return;
          }
          this.allCompanyListing(this.currentPage, this.searchTerm, this.activeCompanyType);
          if (localStorage.getItem('viewCompany') === 'true') {
            this.companylisting2(this.viewCurrentPage, this.viewCompanyName);
          }
          this.toast.show('success', data.resultDescription);
        },
        (error: any) => {
          this.authService.dataError(error);
        }
      );
    }
  }

  // ============================================
  // CLICK OUTSIDE HANDLERS
  // ============================================

  onClickOutsideMergeDropdown(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.combo-input-wrapper')) {
      this.showMergeDropdown = false;
    }
  }

  onClickOutsideAddressDropdown(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.combo-input-wrapper')) {
      this.showAddressDropdown = false;
    }
  }

  onModalBackdropClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (target.classList.contains('modal')) {
      this.closeMergeModal();
      this.closeEditModal();
      this.closeAddModel();
      this.closeViewModel();
    }
  }

  // ============================================
  // PAGINATION
  // ============================================
  itemsPerPage = 20;
  totalPages = 1;
  viewTotalPages = 1;
  currentPage = 1;
  viewCurrentPage = 1;

  getPaginationInfo(): string {
    const total = this.companiesDataCount;

    if (total === 0) {
      return 'No companies found';
    }

    this.totalPages = Math.ceil(total / this.itemsPerPage);

    const start = (this.currentPage - 1) * this.itemsPerPage + 1;
    const end = Math.min(this.currentPage * this.itemsPerPage, total);
    return `Showing ${start} - ${end} of ${total} Companies`;
  }

  getViewPaginationInfo(): string {
    const total = this.viewCompanyDataCount;

    if (total === 0) {
      return 'No companies found';
    }

    this.viewTotalPages = Math.ceil(total / this.itemsPerPage);

    const start = (this.viewCurrentPage - 1) * this.itemsPerPage + 1;
    const end = Math.min(this.viewCurrentPage * this.itemsPerPage, total);
    return `Showing ${start} - ${end} of ${total} companies`;
  }

  goToPreviousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.allCompanyListing(this.currentPage, this.searchTerm, this.activeCompanyType);
    }
  }

  goToViewPreviousPage() {
    if (this.viewCurrentPage > 1) {
      this.viewCurrentPage--;
      this.companylisting2(this.viewCurrentPage, this.viewCompanyName);
    }
  }

  goToNextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.allCompanyListing(this.currentPage, this.searchTerm, this.activeCompanyType);
    }
  }

  goToViewNextPage() {
    if (this.viewCurrentPage < this.viewTotalPages) {
      this.viewCurrentPage++;
      this.companylisting2(this.viewCurrentPage, this.viewCompanyName);
    }
  }

  cross: boolean = false;

  clearText() {
    this.searchTerm = '';
    this.cross = false;
    this.allCompanyListing(this.currentPage, '', this.activeCompanyType);
  }

  // ============================================
  // ADDRESS
  // ============================================
  address$!: Observable<object[]>;
  addressData: any[] = [];
  addressDataCount: number = 0;

  addressList(page?: number, search_text?: string) {
    this.addressService.addressSearch(page, search_text);
    this.address$ = this.addressService.getAddress();

    this.address$.subscribe((data: any) => {
      this.addressData = data?.result?.results;
      this.addressDataCount = data?.result?.count;
      this.addressData?.forEach((element: any, index: number) => {
        element['sNo'] = (index + 1) + (20 * (this.currentPage - 1));
      });
    });
  }

  addaddressList(page?: number, search_text?: string) {
    this.addressService.addressSearch(page, search_text);
    this.address$ = this.addressService.getAddress();

    this.address$.pipe(take(1)).subscribe((data: any) => {
      this.addressData = data?.result?.results;
      this.addressInput = this.addressData[0].address;
      this.addressId = this.addressData[0].id;
      this.addressInputselection = true;
    });
  }

  // ============================================
  // EXISTING - companylisting (used for merge dropdown search)
  // ============================================
  companiess$!: Observable<object[]>;
  totalCompanies: any;
  companyData: any;
  companiesDataCount: any;

  companylisting(page: number, search_text?: string): void {
    this.companyService.companySearch(page, search_text);
    this.companiess$ = this.companyService.getCompanyess();

    this.companiess$.subscribe((data: any) => {
      this.totalCompanies = data?.result?.count || 0;
      this.companyData = data?.result?.results || [];
      this.companiesDataCount = data?.result?.count;
      this.companyData.forEach((element: any, index: number) => {
        element['sNo'] = index + 1 + (20 * (this.currentPage - 1));
        const randomAvatar = Math.floor(Math.random() * 6) + 1;
        element['avatarClass'] = `avatar-${randomAvatar}`;
      });
    });
  }

  companylisting1(page: number, search_text?: string): void {
    this.companyService.companySearch(page, search_text);
    this.companiess$ = this.companyService.getCompanyess();

    this.companiess$.subscribe((data: any) => {
      this.filteredMergeCompanies = data?.result?.results || [];
    });
  }

  // ============================================
  // VIEW COMPANY LISTING
  // ============================================
  totalViewCompany: any;
  viewCompanyData: any;
  viewCompanyDataCount: any;
  viewcompaniess$!: Observable<object[]>;

  companylisting2(page?: number, company_name?: string) {
    this.companyService.viewcompanySearch(page, company_name);
    this.viewcompaniess$ = this.companyService.viewgetCompanyess();

    this.viewcompaniess$.subscribe((data: any) => {
      this.totalViewCompany = data?.result?.count;
      this.viewCompanyData = data?.result?.results;
      this.viewCompanyDataCount = data?.result?.count;
      this.viewCompanyData?.forEach((element: any, index: number) => {
        element['sNo'] = (index + 1) + (20 * (this.viewCurrentPage - 1));
        const randomAvatar = Math.floor(Math.random() * 6) + 1;
        element['avatarClass'] = `avatar-${randomAvatar}`;
      });
    });
  }

  // ============================================
  // HELPERS
  // ============================================
  getCompanyInitials(company: any): string {
    if (!company) {
      return '';
    }
    return company
      .trim()
      .split(' ')
      .filter((word: string | any[]) => word.length > 0)
      .map((word: string[]) => word[0].toUpperCase())
      .join('');
  }

  openDialog(
    enterAnimationDuration: string,
    exitAnimationDuration: string,
  ): void {
    const dialogRef = this.dialog.open(AddAddressListingComponent, {
      width: '800px',
      enterAnimationDuration,
      exitAnimationDuration,
      data: {
        isCloseBtn: true
      },
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.addaddressList(1);
      }
    });
  }
}